import { useQuery } from '@tanstack/react-query';
import { getProgress } from '../api/progress';

export function useProgress(childId) {
  return useQuery({
    queryKey: ['progress', childId],
    queryFn: () => getProgress(childId),
    enabled: !!childId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
